module.exports = __webpack_public_path__ + "img/norway-transport-accidents-male.3834eb29.png";